module.exports = __webpack_public_path__ + "img/monitor9.31fd5c96.jpg";